import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=1ff10c5e&scoped=true"
import script from "./Screen.vue?vue&type=script&lang=js"
export * from "./Screen.vue?vue&type=script&lang=js"
import style0 from "./Screen.vue?vue&type=style&index=0&id=1ff10c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff10c5e",
  null
  
)

export default component.exports